import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function getPriceMatchItem(barcode) {
  const res = await axios.get(`${API_BASE}/price-match/item/${encodeURIComponent(barcode)}`, { headers: authHeader() });
  return res.data;
}

export async function createPriceMatch(data) {
  const res = await axios.post(`${API_BASE}/price-match`, data, { headers: authHeader() });
  return res.data;
}

export async function getLivePriceMatches() {
  const res = await axios.get(`${API_BASE}/price-match/live`, { headers: authHeader() });
  return res.data;
}

export async function getPastPriceMatches(offset = 0, limit = 50) {
  const res = await axios.get(`${API_BASE}/price-match/past`, { headers: authHeader(), params: { offset, limit } });
  return res.data; // { total, rows }
}
